// extracted by mini-css-extract-plugin
export default {"container":"insert-password_container__VHG2B","paper":"insert-password_paper__1cq90","title":"insert-password_title__cDryK","subtitle":"insert-password_subtitle__-BAoq"};